import React from "react";
import cx from "classnames";
import RCTooltip from "rc-tooltip";
import styles from "./Tooltip.module.scss";

export type Trigger = "hover" | "click" | "focus";

export type Placement =
  | "left"
  | "right"
  | "top"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight";

// TODO: figure out how to extend the rc-tooltip ones
/* eslint-disable @typescript-eslint/ban-types */
export interface RCTooltipProps {
  overlayClassName?: string;
  trigger?: Trigger[];
  mouseEnterDelay?: number;
  mouseLeaveDelay?: number;
  overlayStyle?: React.CSSProperties;
  prefixCls?: string;
  transitionName?: string;
  onVisibleChange?: (visible?: boolean) => void;
  afterVisibleChange?: (visible?: boolean) => void;
  visible?: boolean;
  defaultVisible?: boolean;
  placement?: Placement | Object;
  align?: Object;
  onPopupAlign?: (popupDomNode: Element, align: Object) => void;
  overlay: React.ReactNode;
  arrowContent?: React.ReactNode;
  getTooltipContainer?: () => Element;
  destroyTooltipOnHide?: boolean;
  id?: string;
}
/* eslint-enable @typescript-eslint/ban-types */

export interface TooltipProps extends RCTooltipProps {
  className?: string;
  theme?: "neutral" | "light" | "success" | "danger";
}

const Tooltip: React.FC<TooltipProps> = ({
  className,
  children,
  theme = "neutral",
  overlay,
  placement = "top",
  ...otherProps
}) => {
  return (
    <RCTooltip
      overlay={overlay}
      overlayClassName={cx(styles.overlay, className, {
        "phasers-tooltip-neutral": theme === "neutral",
        "phasers-tooltip-light": theme === "light",
        "phasers-tooltip-success": theme === "success",
        "phasers-tooltip-danger": theme === "danger",
      })}
      prefixCls="phasers-tooltip"
      trigger={["hover"]}
      placement={placement}
      {...otherProps}
    >
      {children}
    </RCTooltip>
  );
};

export default Tooltip;
